import { QueueViewColumn } from './column.interface';
import { BackendFieldConverterService } from '../../../../shared/services/backend-field-converter/backend-field-converter.service';

export const ColumnWidth = {
  SHORT: '80px',
  MEDIUM: '160px',
  LONG: '250px'
};

const backendFieldConverter: BackendFieldConverterService = new BackendFieldConverterService();

function chatStatusConverter(chatState: number) {
  switch (chatState) {
    case 0: return 'queueViewTab.chatStates.normal';
    case 1: return 'queueViewTab.chatStates.preChatForm';
    case 2: return 'queueViewTab.chatStates.inChat';
    case 3: return 'queueViewTab.chatStates.preChatFormClosed';
    case 4: return 'queueViewTab.chatStates.chatEnded';
    case 5: return 'queueViewTab.chatStates.sendingTranscript';
    case 6: return 'queueViewTab.chatStates.transcriptSent';
    case 7: return 'queueViewTab.chatStates.unavailableEmailForm';
    case 8: return 'queueViewTab.chatStates.unavailableEmailSent';
    case 9: return 'queueViewTab.chatStates.chatEndedUnanswered';
    case 10: return 'queueViewTab.chatStates.operatorUnavailableBlocked';
    case 11: return 'queueViewTab.chatStates.operatorUnavailableMaxQueue';
    case 12: return 'queueViewTab.chatStates.operatorUnavailableHours';
    case 13: return 'queueViewTab.chatStates.unavailableEmailSentBlocked';
    case 14: return 'queueViewTab.chatStates.unavailableEmailSentMaxQueue';
    case 15: return 'queueViewTab.chatStates.unavailableEmailSentHours';
    case 16: return 'queueViewTab.chatStates.operatorUnavailableLimit';
    case 17: return 'queueViewTab.chatStates.unavailableEmailSentLimit';
    case 18: return 'queueViewTab.chatStates.unsecured';
    default: return chatState;
  }
}

function emailTypeConverter(emailType: number) {
  switch (emailType) {
    case 0: return 'queueViewTab.emailTypes.draft';
    case 1: return 'queueViewTab.emailTypes.inbound';
    case 2: return 'queueViewTab.emailTypes.outbound';
    case 3: return 'queueViewTab.emailTypes.spam';
    case 4: return 'queueViewTab.emailTypes.bounce';
    default: return emailType;
  }
}


function emailThreadTypeConverter(emailThreadType: number) {
  switch (emailThreadType) {
    case 0: return 'queueViewTab.emailThreadTypes.old';
    case 1: return 'queueViewTab.emailThreadTypes.pop3';
    case 2: return 'queueViewTab.emailThreadTypes.compose';
    case 3: return 'queueViewTab.emailThreadTypes.mailingList';
    case 4: return 'queueViewTab.emailThreadTypes.system';
    default: return emailThreadType;
  }
}

function chatTypeConverter(chatType: number): string {
  switch (chatType) {
    case 0: return 'queueViewTab.chatTypes.sms';
    case 1: return 'queueViewTab.chatTypes.facebook';
    case 3: return 'queueViewTab.chatTypes.asyncMessage';
    default: return '';
  }
}

export const ColumnDefinitions = {
  Visitor: {
    displayName: 'queueViewTab.columns.visitor',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'ChatName',
    id: 'chatName',
    sortDirection: 'asc'
  },
  Agent: {
    displayName: 'queueViewTab.columns.agent',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'OperatorName',
    id: 'operatorName',
    sortDirection: 'asc'
  },
  AgentMessageCount: {
    displayName: 'queueViewTab.columns.agentMsgCount',
    baseWidth: ColumnWidth.SHORT,
    valueProperty: 'OperatorMessageCount',
    id: 'operatorMessageCount',
    sortDirection: 'asc'
  },
  VisitorMessageCount: {
    displayName: 'queueViewTab.columns.visitorMsgCount',
    baseWidth: ColumnWidth.SHORT,
    valueProperty: 'VisitorMessageCount',
    id: 'visitorMessageCount',
    sortDirection: 'asc'
  },
  InitialQuestion: {
    displayName: 'queueViewTab.columns.initialQuestion',
    baseWidth: ColumnWidth.LONG,
    valueProperty: 'InitialQuestion',
    id: 'initialQuestion',
    sortDirection: 'asc'
  },
  Created: {
    displayName: 'queueViewTab.columns.created',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Created',
    id: 'created',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  Started: {
    displayName: 'queueViewTab.columns.started',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Started',
    id: 'started',
    sortDirection: 'asc',
    valueTransformer: backendFieldConverter.dateFormatter
  },
  Ended: {
    displayName: 'queueViewTab.columns.ended',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Ended',
    id: 'ended',
    sortDirection: 'asc',
    valueTransformer: backendFieldConverter.dateFormatter
  },
  Updated: {
    displayName: 'queueViewTab.columns.updated',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Updated',
    id: 'updated',
    sortDirection: 'asc',
    valueTransformer: backendFieldConverter.dateFormatter
  },
  Country: {
    displayName: 'queueViewTab.columns.country',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'CountryCode',
    id: 'countryCode',
    sortDirection: 'asc'
  },
  Region: {
    displayName: 'queueViewTab.columns.region',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'RegionCode',
    id: 'regionCode',
    sortDirection: 'asc'
  },
  City: {
    displayName: 'queueViewTab.columns.city',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'City',
    id: 'city',
    sortDirection: 'asc'
  },
  ChatLaunchURL: {
    displayName: 'queueViewTab.columns.chatLaunchUrl',
    baseWidth: ColumnWidth.LONG,
    valueProperty: 'ChatUrl',
    id: 'chatUrl',
    sortDirection: 'asc'
  },
  DepartmentName: {
    displayName: 'queueViewTab.columns.department',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'DepartmentName',
    id: 'departmentName',
    sortDirection: 'asc'
  },
  Answered: {
    displayName: 'queueViewTab.columns.answered',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Answered',
    id: 'answered',
    sortDirection: 'asc',
    valueTransformer: backendFieldConverter.dateFormatter
  },
  ChatID: {
    displayName: 'queueViewTab.columns.chatId',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'ChatID',
    id: 'chatStatusType',
    sortDirection: 'asc'
  },
  TextChatID: {
    displayName: 'queueViewTab.columns.textChatId',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'TextChatID',
    id: 'textChatId',
    sortDirection: 'asc'
  },
  ChatStatus: {
    displayName: 'queueViewTab.columns.status',
    baseWidth: ColumnWidth.SHORT,
    valueProperty: 'ChatStatusType',
    id: 'chatStatusType',
    sortDirection: 'asc',
    valueTransformer: chatStatusConverter,
    translatable: true
  },
  Experiments: {
    displayName: 'queueViewTab.columns.experiments',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Experiments',
    id: 'experiments',
    sortDirection: 'asc'
  },
  VisitorIP: {
    displayName: 'queueViewTab.columns.visitorIp',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'IP',
    id: 'ip',
    sortDirection: 'asc'
  },
  VisitorLastName: {
    displayName: 'queueViewTab.columns.lastName',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastName',
    id: 'lastName',
    sortDirection: 'asc'
  },
  Priority: {
    displayName: 'queueViewTab.columns.priority',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Priority',
    id: 'priority',
    sortDirection: 'asc'
  },
  SurveyNPS: {
    displayName: 'queueViewTab.columns.nps',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'SurveyNps',
    id: 'surveyNps',
    sortDirection: 'asc'
  },
  SurveyOverall: {
    displayName: 'queueViewTab.columns.overall',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'SurveyOverall',
    id: 'surveyOverall',
    sortDirection: 'asc'
  },
  SurveyProfessionalism: {
    displayName: 'queueViewTab.columns.professionalism',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'SurveyProfessionalism',
    id: 'surveyProfessionalism',
    sortDirection: 'asc'
  },
  SurveyResponsiveness: {
    displayName: 'queueViewTab.columns.responsiveness',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'SurveyResponsiveness',
    id: 'surveyResponsiveness',
    sortDirection: 'asc'
  },
  TotalResponseTime: {
    displayName: 'queueViewTab.columns.responseTime',
    baseWidth: ColumnWidth.SHORT,
    valueProperty: 'TotalResponseTime',
    id: 'totalResponseTime',
    sortDirection: 'asc'
  },
  EmailAddress: {
    displayName: 'queueViewTab.columns.emailAddress',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'VisitEmailAddress',
    id: 'visitEmailAddress',
    sortDirection: 'asc'
  },
  Email: {
    displayName: 'queueViewTab.columns.emailAddress',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Email',
    id: 'email',
    sortDirection: 'asc'
  },
  VisitInfo: {
    displayName: 'queueViewTab.columns.visitInfo',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'VisitInfo',
    id: 'visitInfo',
    sortDirection: 'asc'
  },
  VisitorPhone: {
    displayName: 'queueViewTab.columns.phone',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'VisitPhone',
    id: 'visitPhone',
    sortDirection: 'asc'
  },
  PhoneNumber: {
    displayName: 'queueViewTab.columns.phone',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'PhoneNumber',
    id: 'phoneNumber',
    sortDirection: 'asc'
  },
  VisitRef: {
    displayName: 'queueViewTab.columns.visitRef',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'VisitRef',
    id: 'visitRef',
    sortDirection: 'asc'
  },
  Closed: {
    displayName: 'queueViewTab.columns.closed',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Closed',
    id: 'closed',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'desc'
  },
  WebsiteName: {
    displayName: 'queueViewTab.columns.websiteName',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'WebsiteName',
    id: 'websiteName',
    sortDirection: 'asc'
  },
  WindowClosed: {
    displayName: 'queueViewTab.columns.windowClosed',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'WindowClosed',
    id: 'windowClosed',
    sortDirection: 'asc',
    valueTransformer: backendFieldConverter.dateFormatter
  },
  LanguageCode: {
    displayName: 'queueViewTab.columns.languageCode',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LanguageCode',
    id: 'languageCode',
    sortDirection: 'asc'
  },
  VisitorID: {
    displayName: 'queueViewTab.columns.visitorId',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'VisitorID',
    id: 'visitorID',
    sortDirection: 'asc'
  },
  Subject: {
    displayName: 'queueViewTab.columns.subject',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Subject',
    id: 'subject',
    sortDirection: 'asc'
  },
  QueueTime: {
    displayName: 'queueViewTab.columns.queueTime',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'QueueTime',
    id: 'queueTime',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  FirstIncomingArrived: {
    displayName: 'queueViewTab.columns.firstIncomingArrived',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'FirstIncomingArrived',
    id: 'firstIncomingArrived',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  EmailThreadType: {
    displayName: 'queueViewTab.columns.emailThreadType',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'EmailThreadType',
    id: 'emailThreadType',
    valueTransformer: emailThreadTypeConverter,
    translatable: true,
    sortDirection: 'asc'
  },
  LastEmailType: {
    displayName: 'queueViewTab.columns.lastEmailType',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastEmailType',
    id: 'lastEmailType',
    valueTransformer: emailTypeConverter,
    translatable: true,
    sortDirection: 'asc'
  },
  UserEmailName: {
    displayName: 'queueViewTab.columns.userEmailName',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'UserEmailName',
    id: 'userEmailName',
    sortDirection: 'asc'
  },
  UserEmailAddress: {
    displayName: 'queueViewTab.columns.userEmailAddress',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'UserEmailAddress',
    id: 'userEmailAddress',
    sortDirection: 'asc'
  },
  EmailCount: {
    displayName: 'queueViewTab.columns.emailCount',
    baseWidth: ColumnWidth.SHORT,
    valueProperty: 'EmailCount',
    id: 'emailCount',
    sortDirection: 'asc'
  },
  DestinationEmailAddress: {
    displayName: 'queueViewTab.columns.destinationEmailAddress',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'DestinationEmailAddress',
    id: 'destinationEmailAddress',
    sortDirection: 'asc'
  },
  EmailThreadID: {
    displayName: 'queueViewTab.columns.emailThreadId',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'EmailThreadID',
    id: 'emailThreadID',
    sortDirection: 'asc'
  },
  Accepted: {
    displayName: 'queueViewTab.columns.accepted',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Accepted',
    id: 'accepted',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  Opened: {
    displayName: 'queueViewTab.columns.opened',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'Opened',
    id: 'opened',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  LastIncomingArrived: {
    displayName: 'queueViewTab.columns.lastIncomingArrived',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastIncomingArrived',
    id: 'lastIncomingArrived',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  LastAssignedAnswered: {
    displayName: 'queueViewTab.columns.lastAssignedAnswered',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastAssignedAnswered',
    id: 'lastAssignedAnswered',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  EmailAccountName: {
    displayName: 'queueViewTab.columns.emailAccount',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'FromEmailAccount',
    id: 'emailAccountName',
    sortDirection: 'asc'
  },
  AppliedRuleName: {
    displayName: 'queueViewTab.columns.appliedRuleName',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'AppliedRuleName',
    id: 'appliedRuleName',
    sortDirection: 'asc'
  },
  AnsweredByOperatorName: {
    displayName: 'queueViewTab.columns.answeredByAgent',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'AnsweredByOperatorName',
    id: 'answeredByOperatorName',
    sortDirection: 'asc'
  },
  LastAssignedByOperatorName: {
    displayName: 'queueViewTab.columns.lastAssignedByAgent',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastAssignedByOperatorName',
    id: 'lastAssignedByOperatorName',
    sortDirection: 'asc'
  },
  TotalReassignCount: {
    displayName: 'queueViewTab.columns.totalReassign',
    baseWidth: ColumnWidth.SHORT,
    valueProperty: 'TotalReassignCount',
    id: 'totalReassignCount',
    sortDirection: 'asc'
  },
  FolderName: {
    displayName: 'queueViewTab.columns.folderName',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'FolderName',
    id: 'folderName',
    sortDirection: 'asc'
  },
  ClosedByOperatorName: {
    displayName: 'queueViewTab.columns.closedByAgent',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'ClosedByOperatorName',
    id: 'closedByOperatorName',
    sortDirection: 'asc'
  },
  ChatType: {
    displayName: 'queueViewTab.columns.chatType',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'ChatType',
    id: 'chatType',
    valueTransformer: chatTypeConverter,
    translatable: true,
    sortDirection: 'asc'
  },
  LastMessageSent: {
    displayName: 'queueViewTab.columns.lastMessageSent',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastMessageSent',
    id: 'lastMessageSent',
    valueTransformer: backendFieldConverter.dateFormatter,
    sortDirection: 'asc'
  },
  ChannelName: {
    displayName: 'queueViewTab.columns.channelName',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'ChannelName',
    id: 'channelName',
    sortDirection: 'asc'
  },
  LastMessagePersonType: {
    displayName: 'queueViewTab.columns.lastMessagePersonType',
    baseWidth: ColumnWidth.MEDIUM,
    valueProperty: 'LastMessagePersonType',
    id: 'lastMessagePersonType',
    valueTransformer: backendFieldConverter.personTypeConverter,
    translatable: true,
    sortDirection: 'asc'
  }
};

// .NET default display order
//
// Chat State, Chat Type, Last to Send, Is Flagged, Is Unread,
// Operator, OpMsgCnt, VisMsgCnt, Created, VisitorName, IP,
// Country, Region, City, Department, ChatLaunchURL,
// VisitEmail, VisitPhone, VisitRef, Mobility, RelatedTo

export const chatBotColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.EmailAddress,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.ChatLaunchURL,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.VisitorIP,
  ColumnDefinitions.Experiments,
  ColumnDefinitions.ChatID
];

export const chatQueueColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.LastMessagePersonType,
  ColumnDefinitions.InitialQuestion,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.EmailAddress,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.ChatLaunchURL,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.VisitorIP,
  ColumnDefinitions.Priority,
  ColumnDefinitions.Experiments,
  ColumnDefinitions.ChatID
];

export const chatAssignedColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Agent,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.LastMessagePersonType,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.EmailAddress,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.ChatLaunchURL,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.VisitorIP,
  ColumnDefinitions.Priority,
  ColumnDefinitions.Experiments,
  ColumnDefinitions.ChatID
];

export const chatClosedColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Ended,
  ColumnDefinitions.Closed,
  ColumnDefinitions.WindowClosed,
  ColumnDefinitions.Updated,
  ColumnDefinitions.Agent,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.EmailAddress,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.WebsiteName,
  ColumnDefinitions.ChatLaunchURL,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.VisitorIP,
  ColumnDefinitions.SurveyNPS,
  ColumnDefinitions.ChatID,
  ColumnDefinitions.VisitorID
];

export const emailQueueColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.LastIncomingArrived,
  ColumnDefinitions.EmailThreadType,
  ColumnDefinitions.LastEmailType,
  ColumnDefinitions.EmailAccountName,
  ColumnDefinitions.AppliedRuleName,
  ColumnDefinitions.LastAssignedByOperatorName,
  ColumnDefinitions.TotalReassignCount,
  ColumnDefinitions.UserEmailName,
  ColumnDefinitions.UserEmailAddress,
  ColumnDefinitions.Subject,
  ColumnDefinitions.EmailCount,
  ColumnDefinitions.DestinationEmailAddress,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.FolderName,
  ColumnDefinitions.EmailThreadID
];

export const emailAssignedColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.Accepted,
  ColumnDefinitions.Opened,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastIncomingArrived,
  ColumnDefinitions.LastAssignedAnswered,
  ColumnDefinitions.Updated,
  ColumnDefinitions.EmailThreadType,
  ColumnDefinitions.LastEmailType,
  ColumnDefinitions.EmailAccountName,
  ColumnDefinitions.AppliedRuleName,
  ColumnDefinitions.Agent,
  ColumnDefinitions.AnsweredByOperatorName,
  ColumnDefinitions.LastAssignedByOperatorName,
  ColumnDefinitions.TotalReassignCount,
  ColumnDefinitions.UserEmailName,
  ColumnDefinitions.UserEmailAddress,
  ColumnDefinitions.Subject,
  ColumnDefinitions.EmailCount,
  ColumnDefinitions.DestinationEmailAddress,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.FolderName,
  ColumnDefinitions.EmailThreadID
];

export const emailClosedColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.Created,
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.Accepted,
  ColumnDefinitions.Opened,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastIncomingArrived,
  ColumnDefinitions.LastAssignedAnswered,
  ColumnDefinitions.Closed,
  ColumnDefinitions.Updated,
  ColumnDefinitions.EmailThreadType,
  ColumnDefinitions.LastEmailType,
  ColumnDefinitions.EmailAccountName,
  ColumnDefinitions.AppliedRuleName,
  ColumnDefinitions.Agent,
  ColumnDefinitions.AnsweredByOperatorName,
  ColumnDefinitions.LastAssignedByOperatorName,
  ColumnDefinitions.TotalReassignCount,
  ColumnDefinitions.UserEmailName,
  ColumnDefinitions.UserEmailAddress,
  ColumnDefinitions.Subject,
  ColumnDefinitions.EmailCount,
  ColumnDefinitions.DestinationEmailAddress,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.FolderName,
  ColumnDefinitions.ClosedByOperatorName,
  ColumnDefinitions.EmailThreadID
];

export const messagingQueueColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.ChatType,
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.LastMessageSent,
  ColumnDefinitions.LastMessagePersonType,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.InitialQuestion,
  ColumnDefinitions.Email,
  ColumnDefinitions.PhoneNumber,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.Priority,
  ColumnDefinitions.TextChatID,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.FolderName,
  ColumnDefinitions.ChannelName
];

export const messagingAssignedColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.ChatType,
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Agent,
  ColumnDefinitions.LastMessageSent,
  ColumnDefinitions.LastMessagePersonType,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.Email,
  ColumnDefinitions.PhoneNumber,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.TextChatID,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.FolderName,
  ColumnDefinitions.ChannelName
];

export const messagingClosedColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.ChatType,
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Agent,
  ColumnDefinitions.LastMessageSent,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.Email,
  ColumnDefinitions.PhoneNumber,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.TextChatID,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.Ended,
  ColumnDefinitions.Closed,
  ColumnDefinitions.FolderName,
  ColumnDefinitions.ChannelName
];

export const messagingBotColumnConfig: QueueViewColumn[] = [
  ColumnDefinitions.ChatType,
  ColumnDefinitions.Created,
  ColumnDefinitions.Started,
  ColumnDefinitions.Answered,
  ColumnDefinitions.LastMessageSent,
  ColumnDefinitions.LastMessagePersonType,
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.Visitor,
  ColumnDefinitions.Email,
  ColumnDefinitions.PhoneNumber,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.DepartmentName,
  ColumnDefinitions.Country,
  ColumnDefinitions.Region,
  ColumnDefinitions.City,
  ColumnDefinitions.TextChatID,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.ChannelName
];
